import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=157efda2&"
import script from "./CustomerCard.vue?vue&type=script&lang=ts&"
export * from "./CustomerCard.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerCard.vue?vue&type=style&index=0&id=157efda2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports